var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMediaQuery, useTheme } from '@mui/material';
export function useManualPreloadImages(_a) {
    var all = _a.all, mobile = _a.mobile, desktop = _a.desktop;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    var imagesToLoad = __spreadArray(__spreadArray([], ((isMobile ? mobile : desktop) || []), true), (all || []), true);
    var loadImages = function () {
        return Promise.all(imagesToLoad.map(function (src) {
            return new Promise(function (resolve) {
                var img = new Image();
                img.src = src;
                img.onload = function () {
                    resolve();
                };
            });
        }));
    };
    return { loadImages: loadImages };
}
